import { getGenericDocumentsByIds, } from '@zurich/api/document';
import { useApiQuery, useTranslation } from '@zurich/common/hooks';
export const useGetGenericDocumentsByIds = ({ documentIds, }) => {
    const { t } = useTranslation();
    return useApiQuery({
        request: getGenericDocumentsByIds,
        params: {
            vars: {
                documentIds,
            },
        },
        options: {
            errorText: t('document.errors.loadDocument'),
        },
        queryOptions: {
            enabled: !!documentIds,
        },
    });
};
